(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/game-analyses-redux/assets/game-analyses-actions.js') >= 0) return;  svs.modules.push('/components/sportinfo/game-analyses-redux/assets/game-analyses-actions.js');
"use strict";


const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk,
  createAction = _RTK.createAction;
const getDrawAnalyses = svs.content.shared.cms.getDrawAnalyses;
const normalizeAnalyses = svs.components.sportinfo.gameAnalysesRedux.normalizeAnalyses.normalizeAnalyses;
const _svs$components$sport = svs.components.sportinfo.gameAnalysesRedux.normalizeDrawData,
  normalizeDrawData = _svs$components$sport.normalizeDrawData,
  normalizeDrawDataFromAnalyseData = _svs$components$sport.normalizeDrawDataFromAnalyseData;
const products = svs.utils.products;
const log = svs.core.log;
const logger = log.getLogger('game-analyses-redux:game-analyses-actions');
const _svs$components$lbUti = svs.components.lbUtils.apiProxy,
  ApiProxy = _svs$components$lbUti.ApiProxy,
  http = _svs$components$lbUti.http,
  featureToggle = _svs$components$lbUti.featureToggle;
const cloudApiFeatureToggles = svs.components.lbUtils.cloudApi.cloudApiConstants.cloudApiFeatureToggles;
const fetchDrawAnalyses = createAsyncThunk('gameAnalyses/fetchDrawAnalyses', async _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber;
  const analyses = await getDrawAnalyses({
    count: 20,
    id: drawNumber,
    product: productId,
    withLegacyFilter: false
  });
  const normalisedGameAnalyses = normalizeAnalyses(analyses.result);
  const normalizedDrawData = normalizeDrawDataFromAnalyseData(normalisedGameAnalyses);
  return {
    normalisedGameAnalyses,
    normalizedDrawData
  };
});
const fetchDrawData = createAsyncThunk('gameAnalyses/fetchDrawData', async _ref2 => {
  let productId = _ref2.productId,
    drawNumber = _ref2.drawNumber;
  const productName = products.getSpecificDrawName(productId);
  const customHandler = http.get('/draw/1/:product/draws/:drawNumber', _ref3 => {
    let data = _ref3.data;
    return data;
  }, {
    config: {
      shouldUseCloud: async () => {
        const isEnabled = await featureToggle(cloudApiFeatureToggles[productName.toUpperCase()], {
          req: undefined
        });
        return isEnabled;
      },
      allowedProducts: ['bomben', 'matchen', 'europatipset', 'stryktipset'],
      cloudEndpointTemplate: '/v1/:product/draws/:drawNumber'
    }
  });
  const apiProxy = new ApiProxy([customHandler]);
  const data = await apiProxy.fetch("/draw/1/".concat(productName, "/draws/").concat(drawNumber), {
    method: 'GET',
    req: undefined
  });
  let draw;
  if (data.error) {
    logger.info("Error fetching matchId and participantNames, error: ".concat(data.error));
  } else {
    var _data$draw;
    draw = {
      events: data === null || data === void 0 || (_data$draw = data.draw) === null || _data$draw === void 0 ? void 0 : _data$draw.events
    };
  }
  return normalizeDrawData(draw);
});
const setDrawData = createAction('gameAnalyses/setDrawData');
setGlobal('svs.components.sportinfo.gameAnalysesRedux.actions', {
  fetchDrawAnalyses,
  fetchDrawData,
  setDrawData
});

 })(window);